import { render } from "./SaveReport.vue?vue&type=template&id=f1b5d228"
import script from "./SaveReport.vue?vue&type=script&lang=js"
export * from "./SaveReport.vue?vue&type=script&lang=js"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__